// extracted by mini-css-extract-plugin
export default {"ign":"SingleAssetSelfTestOverview_ign__89aay","ign__label":"SingleAssetSelfTestOverview_ign__label__FYrWJ","ign__duration":"SingleAssetSelfTestOverview_ign__duration__Z4UjS"};